import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    h: "Scope",
    body: [
      "This Refund Policy applies to paid engagements, deposits and any prepaid services purchased directly from Imaginepedia Technologies. Terms specific to a particular engagement, if any, are set out in the signed Statement of Work (SoW) and, where they conflict, will take precedence over this policy.",
    ],
  },
  {
    h: "Consulting & engineering engagements",
    body: [
      "Fees for research, engineering and consulting work are billed against milestones or time delivered as described in the SoW. Because these services are custom and time-bound, fees for work already performed are non-refundable.",
      "If an engagement is cancelled before delivery begins, any deposit will be refunded net of costs already incurred (for example, staffing hold fees or third-party licences).",
    ],
  },
  {
    h: "Prepaid retainers",
    body: [
      "Prepaid monthly retainers may be cancelled with fifteen (15) days' written notice. Unused, unearned retainer balance at the effective cancellation date will be refunded within thirty (30) business days.",
    ],
  },
  {
    h: "Defect remediation",
    body: [
      "If a deliverable does not conform to the acceptance criteria in the SoW, we will remediate at no additional cost within the warranty window defined in the SoW. Refunds in lieu of remediation are considered only where remediation is not feasible.",
    ],
  },
  {
    h: "Third-party costs",
    body: [
      "Pass-through costs — such as cloud infrastructure, licences and third-party APIs — are non-refundable once incurred on your behalf.",
    ],
  },
  {
    h: "How to request a refund",
    body: [
      "Send a refund request to hello@imaginepedia.tech with the engagement reference, invoice number and reason. We aim to acknowledge within two (2) business days and resolve within thirty (30) business days.",
    ],
  },
  {
    h: "Chargebacks",
    body: [
      "We ask that you contact us before initiating a chargeback so we can address the concern directly. Unfounded chargebacks may be contested with your payment provider.",
    ],
  },
  {
    h: "Updates",
    body: [
      "We may revise this Refund Policy from time to time. The version in effect on the date of your engagement will apply to that engagement.",
    ],
  },
];

export default function Refund() {
  return (
    <LegalPage
      testId="page-refund"
      index={3}
      label="Legal"
      title="Refund Policy."
      updated="10 December 2025"
      sections={SECTIONS}
    />
  );
}
